import { render, staticRenderFns } from "./FullViewTab.vue?vue&type=template&id=14239280&scoped=true"
import script from "./FullViewTab.vue?vue&type=script&lang=ts"
export * from "./FullViewTab.vue?vue&type=script&lang=ts"
import style0 from "./FullViewTab.vue?vue&type=style&index=0&id=14239280&prod&lang=scss"
import style1 from "./FullViewTab.vue?vue&type=style&index=1&id=14239280&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14239280",
  null
  
)

export default component.exports